import Schema from 'AppReact/schema';
import { optional, required } from 'AppReact/schema';

const ref = {
  current: optional('string'),
};

const floor = {
  id: required('string'),
  display: required('string'),
  code: required('string'),
}

export default {
  containerRef: Schema(ref, 'object', { defaultValue: { current: null } }),
  mapId: Schema('string', 'primitive-nullable', { defaultValue: null }),
  zoom: Schema('number', 'primitive-nullable', { defaultValue: null }),
  map: Schema({}, 'object', { defaultValue: null }),
  floorsList: Schema(floor, 'array', { defaultValue: [] }),
  selectedFloorId: Schema('string', 'primitive-nullable', { defaultValue: null }),
}
